import { Application } from "../../models-v2/Application";

import AxiosService from "../../services/axios-service/AxiosService";
import ErrorHandler from "../../utils/ErrorHandler";
import Storage from "../storage/Storage";

const MANAGER_API_URL = process.env.REACT_APP_MANAGER_API;

export class ApplicationService {
    static async getApplicationById(id: string): Promise<Application> {
        let token, config;
        try {
            token = Storage.get(Storage.KEYS.USERTOKEN);
        } catch (error) {
            ErrorHandler.handleError(error);
        }

        config = {
            headers: {
                Authorization: "Bearer " + token
            }
        };

        const url = MANAGER_API_URL + `/applications/${id}`;
        const resp = await AxiosService.httpGet(url, config);
        return resp.data;
    }
}
